// 261015 P5d (D14) — phần THUẦN của khối «Tình tiết nguyên tác chưa lên phim (N)» ở ScriptReader. KHÔNG import antd (jest của CRA không nạp được antd v6).
// BE tính danh sách ($0 AI, lúc đọc); FE chỉ gắn nhãn/tông và ghi rõ mục nào là SUY ĐOÁN (heuristic) — không tự suy thêm tình tiết nào.
import type { DroppedSourceEvent } from '../../../types/adaptation';

export const DROPPED_HEADING = 'Tình tiết nguyên tác chưa lên phim';

export type DroppedTone = 'bad' | 'warn' | 'muted';
export interface DroppedRowView {
  key: string;
  label: string;
  tone: DroppedTone;
  summary: string;
  /** Trích nguồn ngắn; '' ⇒ không hiện. */
  quote: string;
  reason: string;
  /** Mục suy đoán (không phải kết luận): ý tổng quan chưa thấy bằng chứng cảnh. */
  heuristic: boolean;
}
export interface DroppedView {
  heading: string;
  rows: DroppedRowView[];
  /** Chú thích chung — chỉ khi có mục suy đoán; '' ⇒ không hiện. */
  note: string;
}

const LABELS: Record<string, { label: string; tone: DroppedTone }> = {
  GATE_COVERAGE: { label: 'Giám khảo báo thiếu', tone: 'bad' },
  MISSED_MOMENT: { label: 'Khoảnh khắc kịch tính chưa dựng cảnh', tone: 'warn' },
  INTENTIONAL_CUT: { label: 'Cắt có chủ đích', tone: 'muted' },
  MAYBE_DROPPED_CLAIM: { label: 'Có thể bị bỏ (suy đoán)', tone: 'muted' },
};
const text = (v: unknown): string => String(v ?? '').trim();

/** Không có mục ⇒ `null` (không render khối). Giữ NGUYÊN thứ tự BE; loại lạ vẫn hiện (không giấu). */
export const droppedEventsView = (events: DroppedSourceEvent[] | null | undefined): DroppedView | null => {
  if (!Array.isArray(events) || events.length === 0) return null;
  const rows = events.map((e, i): DroppedRowView => {
    const meta = LABELS[String(e?.kind)] ?? { label: 'Chưa lên phim', tone: 'muted' as DroppedTone };
    return {
      key: `${e?.kind ?? 'x'}-${e?.refId ?? i}-${i}`, label: meta.label, tone: meta.tone,
      summary: text(e?.summary), quote: text(e?.quote), reason: text(e?.reason), heuristic: e?.heuristic === true,
    };
  });
  return {
    heading: `${DROPPED_HEADING} (${rows.length})`,
    rows,
    note: rows.some((r) => r.heuristic) ? 'Mục «có thể bị bỏ» là suy đoán từ bằng chứng nguồn của các cảnh — cảnh có thể đã kể sự việc đó bằng hình; đối chiếu nguyên tác khi cần.' : '',
  };
};
